import Button from "../../../../components/form/Button";
import Event from "../../../../components/sections/front/user-events-collections/Event";
import Tabs from "../../../../components/elements/Tabs";
import Collections from "../../../../components/sections/front/user-events-collections/Collections";
import { useState } from "react";
import ManageEventDrawer from "../../../../components/sections/admin/Event/Drawer/ManageEventDrawer";
import { useOrganization } from "../../../../context/OrganizationContext";
import ManageCollectionDrawer from "../../../../components/sections/admin/Collection/Drawer/ManageCollectionDrawer";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import TicketsList from "../../../../components/sections/front/user-events-collections/TicketsList";
import EventAddModal from "../../../../components/common/EventAddModal";
import { useTranslation } from "react-i18next";

const UserEvents = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { lang } = useSelector((state) => state?.langProvider);
  const { organizations, selectedOrganization } = useOrganization();

  const [selectedTab, setSelectedTab] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState({ isOpen: false, data: null });

  const tabsData = [
    {
      label: t("Events"),
      content: <Event />,
    },
    {
      label: t("Collections"),
      content: <Collections />,
    },
    {
      label: t("Tickets"),
      content: <TicketsList />,
    },
  ];

  return (
    <div className="w-full flex flex-col pb-10 bg-white rounded-md">
      <div className="space-y-8 py-8 px-5">
        <div className="flex flex-col md:flex-row items-end md:items-center justify-between border-b border-gray-300 pb-3 md:pb-0">
          <div className="flex flex-col gap-2 w-full">
            <div className="font-bold text-lg xl:text-2xl tracking-tighter uppercase text-slate-900 font-Montserrat">
              {selectedTab === 0
                ? t("Event")
                : selectedTab === 1
                ? t("Collection")
                : t("Ticket")}{" "}
              {t("Management")}
            </div>
            <div className="font-normal text-text-secondary">
              {t(
                "Easily handle all event actions: update event info, location, status, and add new event data."
              )}
            </div>
          </div>
          {[0, 1].includes(selectedTab) && (
            <div className="relative">
              {selectedTab === 0 ? (
                <EventAddModal triggerButtonLabel="Create event" />
              ) : (
                <Button
                  buttonClasses={""}
                  buttonLabel={t(
                    `Create ${selectedTab === 0 ? "Event" : "Collection"}`
                  )}
                  buttonFunction={() => {
                    if (selectedTab === 0) {
                      navigate(`event-manage`);
                    } else {
                      setDrawerOpen({
                        isOpen: true,
                        data: {
                          type: "collection",
                          organization: selectedOrganization,
                        },
                      });
                    }
                  }}
                />
              )}
            </div>
          )}
        </div>
        <Tabs
          selectedIndex={selectedTab}
          items={tabsData}
          setSelectedIndex={(index) => {
            setDrawerOpen({ isOpen: false, data: null });
            setSelectedTab(index);
          }}
          contentClass={"w-full p-0 md:px-5"}
          tabsClass="gap-3 p-3 md:p-5 flex items-center gap-4 shadow-lg rounded-lg border-t border-slate-100 overflow-auto"
          tabClass={
            "h-11 rounded-full bg-transparent border border-gray-200 flex items-center justify-center !text-deep-purple p-5 text-base capitalize font-normal"
          }
          activeTabClass={"bg-primary border border-primary !text-white"}
        />
      </div>
      {drawerOpen?.data?.type === "event" && (
        <ManageEventDrawer
          open={drawerOpen?.isOpen}
          data={drawerOpen?.data}
          close={() => setDrawerOpen({ isOpen: false, data: null })}
          getResponse={(res) => {
            // see the action in events sec of tabs
            window.dispatchEvent(new CustomEvent("addEvent", { detail: res }));
          }}
        />
      )}
      {drawerOpen?.data?.type === "collection" && (
        <ManageCollectionDrawer
          open={drawerOpen?.isOpen}
          data={drawerOpen?.data}
          close={() => setDrawerOpen({ isOpen: false, data: null })}
          getResponse={(res) => {
            // see the action in collections sec of tabs
            window.dispatchEvent(
              new CustomEvent("addCollection", { detail: res })
            );
          }}
        />
      )}
    </div>
  );
};

export default UserEvents;
